import { useMemo } from 'react';
import type { I18n } from '@lingui/core';
import { useLingui } from '@lingui/react';

import { Flex, Heading, Paragraph } from '@rover/kibble/core';
import Banner from '@rover/kibble/official-patterns/Banner';
import { FullStar } from '@rover/kibble/patterns/StarRating/StarRating.common';
import type { ServiceTypeSimple } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSimple';
import { syndeticJoin } from '@rover/utilities/array';

import type { TrainerReviewsInfo } from './FullMixedReviewsList';

function servicesToText(services: ServiceTypeSimple[], i18n: I18n): string {
  const serviceNames = services.map((service) => service.name);
  serviceNames.sort((a, b) => {
    if (a === 'Dog Training') {
      return -1;
    }
    if (b === 'Dog Training') {
      return 1;
    }
    return a.localeCompare(b);
  });
  // TODO DEV-104195 Translate services before joining
  return syndeticJoin(serviceNames, i18n);
}

interface InsightsOverviewProps {
  trainerInfo: TrainerReviewsInfo;
}
export default function InsightsOverview({ trainerInfo }: InsightsOverviewProps): JSX.Element {
  const { i18n } = useLingui();
  const servicesString = useMemo(
    () => servicesToText(trainerInfo.trainerInsights.servicesWithRatings, i18n),
    [trainerInfo, i18n]
  );
  const formattedRatingsAverage = trainerInfo.trainerInsights?.allServiceAverageRating?.toFixed(1);

  return (
    <Flex flexDirection="column">
      <Flex py="3x" gap="3x" alignItems="center">
        <FullStar size={24} disabled={false} />
        <Flex flexDirection="column">
          <Heading size="400" m="0x">
            {formattedRatingsAverage}
          </Heading>
          {/* TODO DEV-104195 Translate "for" */}
          <Paragraph size="100" textColor="tertiary" m="0x">
            for {servicesString}
          </Paragraph>
        </Flex>
      </Flex>
      <Banner severity="info" hideIcon containerProps={{ borderRadius: 'primary', mb: '6x' }}>
        This star rating comes from verified services provided on Rover.
      </Banner>
    </Flex>
  );
}
